import { IDictionaryCurrency, IDictionarySizeDescription } from '@/creditflowresearch/domain/vo/IDictionary';
import { formatNumberWithDecimals } from '@/creditflowresearch/ui/components/deals/helpers';

interface IFormattedTrancheSizeValues {
  displayValue: string,
  tooltipValue: string | null,
  tooltipSuffix: string,
}

interface IFormattedTrancheSizeValuesProps {
  size: number | null,
  sizeDescription: IDictionarySizeDescription | null,
  currency?: IDictionaryCurrency | null,
  benchmarkSize?: boolean,
  isShowSizeDescription: boolean,
  decimals?: number,
}

export const formatTrancheSizeValues = ({
  size,
  sizeDescription,
  currency,
  benchmarkSize,
  isShowSizeDescription,
  decimals = 0,
}: IFormattedTrancheSizeValuesProps): IFormattedTrancheSizeValues | null => {
  const { name = '', abbreviation = '' } = sizeDescription || {};
  const displaySuffix = isShowSizeDescription ? ` ${ abbreviation.toLowerCase() }` : '';
  const tooltipSuffix = isShowSizeDescription ? ` ${ name }` : '';

  const currencyDisplayPrefix = currency?.abbreviation ?? '';
  const currencyTooltipPrefix = currency?.displayName ?? '';

  const hasExtraInfo = !!currency || !!tooltipSuffix;

  if (size) {
    const formattedSize = formatNumberWithDecimals(size, decimals);
    const displayValue = `${ currencyDisplayPrefix }${ formattedSize }${ displaySuffix }`;

    const tooltipValue = hasExtraInfo
      ? `${ currencyTooltipPrefix } ${ formattedSize }${ tooltipSuffix }`
      : null;

    return { displayValue, tooltipValue, tooltipSuffix };
  }

  if (benchmarkSize) {
    const displayValue = `${ currencyDisplayPrefix } BMK${ displaySuffix }`;

    const tooltipValue = hasExtraInfo
      ? `${ currencyTooltipPrefix } Benchmark Size${ tooltipSuffix }`
      : null;

    return { displayValue, tooltipValue, tooltipSuffix };
  }

  return null;
};
